import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { useAllCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const PostCountryField = ({
  className,
  ...restProps
}: Omit<SingleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions({ hasAllCountryOption: true });

  return (
    <SelectorField<InfluencersFilterFormKeys>
      clearable={false}
      name="countryId"
      options={allCountryOptions}
      className={cn('max-w-38.5', className)}
      placeholder={t<string>('Selector.Countries')}
      {...restProps}
    />
  );
};
